<!--
/*******************************************************************************
*@ 컴포넌트명   : TrsaccRsultInqDtlRpt1.vue
*@ 컴포넌트설명 : 타행이체 - 이체 상세내용
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="transfer">
    <popup
      :opened.sync="openData"
      :use-header="true"
      :use-footer="true"
      class="popup"
      @cancel="popupClose"
    >
      <template #subtitle>
        <h2>{{ /*신청 상세 내용*/ $t("MPAY-04-01-10-22") }}</h2>
      </template>
      <template #content>
        <div class="divider">
          <span
            class="divider-date"
          >{{ /*신청 일시*/ $t("MPAY-04-01-11-02") }} : {{$getGlobalDateFmt(detailInfo.drblYms)}}</span>
        </div>
        <div class="cont-tit">
          <h6>{{ /*이체 결과*/ $t("MPAY-04-01-13-03") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /* 이체 구분 */ $t("MPAY-04-01-12-04") }}</dt>
          <dd class="right">{{ /* 타행 이체 */ $t("MINQ-01-01-06-18") }}</dd>
          <dt>{{ /*신청 일시*/ $t("MPAY-04-01-07-02") }}</dt>
          <dd class="right">{{ $getGlobalDateFmt(detailInfo.drblYmd) }}</dd>
          <dt>{{ /*처리상태*/ $t("MPAY-04-01-11-17") }}</dt>
          <dd class="right">{{$t(`${detailInfo.ovsesRmtancPrcssDstcd}_해외송금처리구분코드`) }}</dd>
        </dl>
        <template v-if="siteCode == $config.SITECODE_OGHCM && detailInfo.rmtancPtrnDstcd!='03'">
          <div
            class="info info-etc-col"
          >{{ /*실제 거래 결과는 거래내역조회에서 하실 수 있습니다.*/"※ " + $t("MFXD-01-02-02-08")}}</div>
        </template>
        <div class="cont-tit">
          <h6>{{ /*출금 정보*/ $t("MPAY-04-01-12-09") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /*출금 계좌 번호*/ $t("MPAY-04-01-12-10") }}</dt>
          <dd class="right">{{ detailInfo.drwotAcno }}</dd>
          <dt>{{ /*예금주명*/ $t( "MLON-01-01-11-05") }}</dt>
          <dd class="right">{{ detailInfo.drwotDpstrName }}</dd>
          <dt>{{ /*출금 금액*/ $t("MPAY-04-01-12-12") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{detailInfo.drwotCncycd}}</span>
            <span class="amount">{{$num(detailInfo.anticiDrwotAmt)}}</span>
          </dd>
          <dt>{{ /*수수료*/ $t("MPAY-04-01-10-06") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{detailInfo.drwotCncycd}}</span>
            <span class="amount">{{$num(detailInfo.anticiFee)}}</span>
          </dd>
          <dt>{{ /*송금메모*/ $t("MPAY-04-01-10-07") }}</dt>
          <dd class="right">{{ detailInfo.drwotTrsaccMemo }}</dd>
        </dl>
        <div class="cont-tit">
          <h6>{{ /*입금 정보*/ $t("MPAY-04-01-10-08") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <template v-if="siteCode != $config.SITECODE_OGAUC">
            <dt>{{ /* 은행명 */ $t("MPAY-04-01-10-09") }}</dt>
            <dd class="right">{{ detailInfo.mnrcvOthrBnkName }}</dd>
          </template>
          <template v-if="siteCode==$config.SITECODE_OGMMR || siteCode == $config.SITECODE_OGIND">
            <dt>{{ /* 입금 지점 */ $t("MPAY-02-01-26-17") }}</dt>
            <dd class="right">{{ detailInfo.mnrcvBrnName }}</dd>
          </template>
          <dt>{{ /*입금 계좌번호*/ $t("MPAY-04-01-10-10") }}</dt>
          <dd class="right">{{ detailInfo.mnrcvAcno }}</dd>
          <dt>{{ /*입금 금액*/ $t("MPAY-04-01-10-11") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{detailInfo.mnrcvCncycd}}</span>
            <span class="amount">{{$num(detailInfo.mnrcvTrsaccAmt)}}</span>
          </dd>
          <dt>{{ /*수취인*/ $t("MPAY-04-01-12-17") }}</dt>
          <dd class="right">{{ detailInfo.mnrcvDpstrName }}</dd>
          <dt>{{ /*Particulars*//*수취인 참조내용*/ siteCode == $config.SITECODE_OGAUC ? $t("MPAY-02-01-12-22") : $t("MPAY-04-01-06-A14")}}</dt>
          <dd class="right">{{ detailInfo.mnrcvDraweRefCtnt }}</dd>
          <template v-if="siteCode == $config.SITECODE_OGAUC">
            <dt>{{ /*Code*/ $t("MPAY-04-01-10-13") }}</dt>
            <dd class="right">{{ detailInfo.draweCd }}</dd>
            <dt>{{ /*Reference*/ $t("MPAY-02-01-12-21") }}</dt>
            <dd class="right">{{ detailInfo.remark }}</dd>
          </template>
        </dl>
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          @click="popupClose()"
        >{{ /*확인*/ $t("MPAY-04-01-12-19") }}</button>
      </template>
    </popup>
  </section>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapFields(["siteCode", "operGroupCd"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    popupClose() {
      this.openData = false;
      this.$emit("popupClose", false);
    },
  },
};
</script>
